import React, {
  useRef,
  useImperativeHandle,
  useEffect,
  forwardRef,
} from "react";

import { useSpring, a, SpringConfig, SpringValue, to } from "@react-spring/web";
import {
  initialOffset,
  defaultSpringConfig,
} from "components/Animations/SpringProperties/SpringProperties";

import classNames from "classnames";

export type IBackgroundShadeTypes = "light" | "dark";

interface IOwnSpecificProps {
  animateIn: boolean;
  visible: boolean;
  backgroundShade: IBackgroundShadeTypes;
}

type IOwnProps = IOwnSpecificProps;

type IProps = IOwnProps;

const DragHandComponent: React.FC<IProps> = ({
  animateIn,
  visible,
  backgroundShade,
  ...props
}) => {
  const animateInSpringConfig: SpringConfig = {
    ...defaultSpringConfig,
    tension: 250,
  };

  const [animateSpring, setAnimateSpring] = useSpring(() => ({
    x: 0,
    opacity: 0,
    config: animateInSpringConfig,
  }));

  useEffect(() => {
    setAnimateSpring({ x: animateIn ? 1 : 0 });
  }, [animateIn]);

  useEffect(() => {
    setAnimateSpring({ opacity: visible ? 1 : 0 });
  }, [visible]);

  const dragHandStyles = {
    opacity: to(
      [animateSpring.x, animateSpring.opacity],
      (x, opacity) => x * opacity
    ),
    transform: animateSpring.x.to(
      (x) => `translateY(calc(${initialOffset(x)})) translateX(-100%)`
    ),
  };

  return (
    <a.div
      className={classNames(
        "dragHandIcon",
        [backgroundShade + "BackgroundShade"],
        { textLight: backgroundShade === "dark" },
        { textDark: backgroundShade === "light" }
      )}
      style={dragHandStyles}
    >
      <div>Get a closer look by dragging through</div>
    </a.div>
  );
};
export const DragHand = DragHandComponent;
